const styles = () => ({
    containerForm: {
        position: 'relative',
        paddingBottom: '60px',
    },
    containerDays: {
        margin: '10px 0 30px 0',
    },
    finalizeContainer: {
        position: 'absolute',
        right: '-1.13em',
        width: 'calc(100% + 4em)',
        bottom: '-1.2em',
        backgroundColor: '#e9e9e9',
        justifyContent: 'flex-end',
        padding: '20px',
    },
    finalizeBtn: {
        borderRadius: '25px',
        paddingRight: '20px',
        paddingLeft: '20px',
        height: '50px',
    },
    colorWhite: {
        color: '#fff',
    },
    actionsContainer: {
        flex: 1,
        padding: '30px',
        margin: '50px 12px 0 12px',
        display: 'flex',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    actionsBtns: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
    },
    actionsBtnsRevisionRequest: {
        borderRadius: '20px',
        width: '190px',
        height: '40px',
        float: 'right',
    },
    centerProgress: {
        textAlign: 'center',
    },
});

export default styles;
